import styles from "./Home.module.css";
import React, { Fragment } from "react";
import HomeBoxes from "../../components/homeBoxes/HomeBoxes";

const Home = () => {
    return (
        <Fragment>
            <div className={styles.page_wrapper}>
                <h1 className={styles.title}>
                    Your best <span id={styles.keyword}>mate</span> in everything matrix-related
                </h1>
            </div>
            <HomeBoxes/>
        </Fragment>
    );

};

export default Home;